import React from 'react';
import { Button } from '@material-ui/core';


// The old script's own column names, so an operator recognises the template.
const headers = 'SKU NO,New Price';
const sampleData = [
  'SKUPROD001-EX,92\n',
  'SKUPROD002-EX,149.50\n'
];

const DownloadTemplateButton = () => {
  const downloadTemplate = () => {
    const fileName = 'bulk_price_update_template.csv';
    const fileType = 'text/csv';

    const blob = new Blob([`${headers}\n`].concat(sampleData), { type: fileType });

    const a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  return (
    <Button
      variant="outlined"
      color="primary"
      className="bg-light-blue text-14 font-bold"
      onClick={downloadTemplate}
    >
      Download our CSV Spreadsheet Template
    </Button>
  );
};

export default React.memo(DownloadTemplateButton);
